export default __webpack_public_path__ + "c15aeab25a4b7532e7bb2789df3c26b0.png";